import React, { useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { COLOR_WHITE } from "../../const";
import ProductList from "./ProductList";
import ProductOption from "./product_ption/ProductOption";
import { useTranslation } from "react-i18next";

function ProductTab() {
  const { t } = useTranslation();
  const [activeKey, setActiveKey] = useState("general");

  const handleSelect = (key) => {
    if (!key) return;
    setActiveKey(key);
  };

  return (
    <div className="p-4">
      <Tabs
        activeKey={activeKey}
        onSelect={handleSelect}
        id="product-tab"
        className="mb-3"
        style={{ background: COLOR_WHITE }}
      >
        <Tab eventKey="general" title={t("product_tab_general")}>
          {activeKey === "general" && <ProductList />}
        </Tab>
        <Tab eventKey="option" title={t("product_tab_variant")}>
          {activeKey === "option" && <ProductOption />}
        </Tab>
      </Tabs>
    </div>
  );
}

export default ProductTab;
